import React from 'react'
import PropTypes from 'prop-types'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import './style.scss'
import DescriptionForReviewFeedbackForm from './DescriptionForReviewFeedbackForm'
import { descriptionForReviewShape } from './shapes'

const LAST_MODIFIED_FORMAT = 'DD/MM/YYYY h:mm a'

const DescriptionForReview = ({ title, descriptionForReview, onSubmitFeedback, onCheckFactsheet }) => {
  const { t } = useTranslation()
  const { lastModified } = descriptionForReview.propertyDescription
  return (
    <div className="description-for-review-block">
      <div className="description-for-review">
        <div className="description-for-review__header">
          <h2 className="description-for-review__title">{title}</h2>
        </div>
        <div className="description-for-review__content">
          {descriptionForReview.propertyDescription.description.sections.map((section) => (
            <div key={section.sectionId ?? section.title} className="description-for-review-section">
              <h3 className="description-for-review-section__title">{section.title}</h3>
              <p className="description-for-review-section__body">{section.text}</p>
            </div>
          ))}
        </div>
        {onSubmitFeedback && (
          <div className="description-for-review__feedback">
            <DescriptionForReviewFeedbackForm
              onSubmitFeedback={onSubmitFeedback}
              onCheckFactsheet={onCheckFactsheet}
              existingFeedback={descriptionForReview.existingFeedback}
            />
          </div>
        )}
      </div>
      {lastModified && (
        <p className="description-for-review-last-modified">
          {t('openContentLink.descriptionForReview.lastModified', {
            date: dayjs(lastModified).format(LAST_MODIFIED_FORMAT),
          })}
        </p>
      )}
    </div>
  )
}

DescriptionForReview.propTypes = {
  title: PropTypes.string.isRequired,
  descriptionForReview: descriptionForReviewShape.isRequired,
  onSubmitFeedback: PropTypes.func,
  onCheckFactsheet: PropTypes.func,
}

export default DescriptionForReview
